import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'dropdownOptionsPrepPipe',
    standalone: false
})

export class DropdownOptionsPrepPipe implements PipeTransform {


  constructor(private translateService: TranslateService) {
  }

  newArray = [];
  emptyOption = {
    label: null,
    value: null,
    isEmpty: true
  };

  /**
   * Добавляет в массив объектов для вывода в in-dropdown пустой объект, если текущее значение undefined или null или поле необязательно.
   *
   * @param arr - массив объектов
   * @param current - текущее значение
   * @param isRequired – признак, что поле обязательно для заполнения
   * @param optionKey – название свойства объекта, выводимого в label
   * @returns – массив объектов, содержащий объект со значением value null или undefined, либо исходный массив объектов без изменений.
   */

  transform(arr: Array<any>, current: Object, isRequired = false, optionKey: string): any {
      // Временно решение до ngPrime 15.x добавлять label
      if (arr && Array.isArray(arr)) {
          arr = arr.map(item => {
              if (typeof item === 'object' && item !== null) {
                  item['label'] = item[optionKey];
              }
              return item;
          } );
      }
    if ( arr && current !== null && current !== undefined && current[optionKey] !== '' ) {

      if ( isRequired) {
        return arr;
      } else {
        this.emptyOption[optionKey] = this.emptyOption.label;
        //this.newArray = arr.concat([this.emptyOption]);
        this.newArray = [this.emptyOption].concat(arr);
        return this.newArray;
      }
    } else {
      this.emptyOption[optionKey] = '';
      this.newArray = [this.emptyOption].concat(arr);
      return this.newArray;
    }
  }
}
